import { generateActions } from "utils/generateActions";

export const GET_USER = generateActions("GET_USER");
export const LOGIN = generateActions("LOGIN");
export const LOGOUT = generateActions("LOGOUT");
